import { useAppSelector } from '@store';
import { ApplicationType } from '../../../hoc/new-application/types';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { CustomerType, RiskScoringTypes } from '../../../hoc/customers/types';
import { AmlComponentProps } from './types';

const DeliveryChannels = ({
  expandedRows,
  setExpandedRows,
  values,
  // onSend,
  // onDelete,
  type,
  isEditable,
}: AmlComponentProps) => {
  const { deliveryChannelsIndividual, deliveryChannelsCorporate } =
    useAppSelector((state) => state.customersDictionaries);

  return (
    <ExpandableRow
      name={RiskScoringTypes.DELIVERY_CHANNEL}
      title="Delivery channel"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.deliveryChannelRisk as number}
      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      <ExpandableRowContent
        value={values?.deliveryChannelId as string}
        risk={
          values?.deliveryChannelRisk?.toString() !== 'null' &&
          values?.deliveryChannelRisk?.toString() !== 'undefined'
            ? (values?.deliveryChannelRisk?.toString() as string)
            : '-'
        }
        list={
          type === CustomerType.CORPORATE || type === ApplicationType.CORPORATE
            ? deliveryChannelsCorporate
            : deliveryChannelsIndividual
        }
        name="channel"
        isEditable={isEditable}
      />
    </ExpandableRow>
  );
};

export default DeliveryChannels;
